export const DEFAULT_PATH_COLOR = '#DC143C';
